import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LevelJourneyModel } from "./LevelJourneyModel";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { Theme } from "../../core/Models/CustomSiteConfigModel";

import "./LevelJourney.css";
import Utils from "../../core/Utils/Utils";

const LevelJourney: React.FC<{ blok: LevelJourneyModel }> = ({ blok }) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());
  const navigate = useNavigate();

  const handleClick = () => {
    if (blok.link?.cached_url) {
      if (blok.link?.linktype === "story") {
        navigate(`/${blok.link.cached_url}`);
      } else {
        const url = new URL(blok.link.cached_url, window.location.origin);
        window.location.href = url.href;
      }
    }
  };

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div
      className="level-journey"
      onClick={handleClick}
      style={{
        backgroundColor: theme?.containerColor,
        color: theme?.textColor,
      }}
    >
      <div
        className="journey-image"
        style={{ backgroundColor: blok.backgroundColor }}
      >
        <img
          src={Utils.getCacheUrl(blok.image?.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.image?.filename)}
        />
      </div>
      <div className="journey-title">{blok.title}</div>
      <div className="journey-description">{blok.description}</div>
    </div>
  );
};

export default LevelJourney;
